import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

import styles from '../../MenuItem.module.scss';
import { ReactComponent as IconAccount } from '../../../../assets/icons/icon_account-menu.svg';

const AccountButton = ({ handleMenuLinkClick, socialFeaturesData }) => {
  // Check if streak feature is enabled
  const showStreakReminders = useFeatureIsOn('streak-reminders');

  // Get streak count from social features data
  const streakDays = socialFeaturesData?.data?.streakDays || 0;

  // Only show streak if feature is enabled and streak exists
  const showStreak = showStreakReminders && streakDays > 0;

  return (
    <li className={styles['link-wrapper']}>
      <NavLink
        to={'/account'}
        onClick={() => handleMenuLinkClick('account')}
        activeClassName={styles.isActive}
        className={styles.menuItem}
        data-testid="account-button-link">
        <div className={styles['button-wrapper']}>
          <div className={styles['background']}>
            <IconAccount />
          </div>
          <span>Account</span>

          {/* Display streak count if available */}
          {showStreak && (
            <div className={styles['streak-indicator']}>
              <span className={styles['streak-count']}>
                {streakDays} day{streakDays > 1 ? 's' : ''} streak
              </span>
              <span className={styles['streak-flame']}>🔥</span>
            </div>
          )}
        </div>
      </NavLink>
    </li>
  );
};

AccountButton.propTypes = {
  handleMenuLinkClick: PropTypes.func.isRequired,
  socialFeaturesData: PropTypes.object
};

AccountButton.defaultProps = {
  socialFeaturesData: {}
};

const mapStateToProps = (state) => ({
  socialFeaturesData: state.socialFeaturesData
});

export default connect(mapStateToProps)(AccountButton);
